import {Types} from "../../../type/Types";

export type ShoppingExcelExportValueObject = {
    id: bigint
    adminId: bigint | null,
    status: string,
    s3Key: string,
    memo: string | null,
    createdAt: Date,
    respondedAt: Date | null,
    deletedAt: Date | null
}

export namespace ShoppingExcelExportValueObject {
    export function construct(o: any): ShoppingExcelExportValueObject {
        return {
            id: BigInt(o.id),
            adminId: Types.asNull(o.adminId,BigInt),
            status: String(o.status),
            s3Key: String(o.s3Key),
            memo: Types.asNull(o.memo,String),
            createdAt: new Date(o.createdAt),
            respondedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof ShoppingExcelExportValueObject, string> = {
        id: 'ID',
        adminId: '관리자 ID',
        status: '상태',
        s3Key: '다운로드',
        memo: '메모',
        createdAt: '생성 시각',
        respondedAt: '응답 시각',
        deletedAt: '삭제 시각',
    }
}